// extracted by mini-css-extract-plugin
export var discard = "_4e-3";
export var muiTooltipTooltip = "_4e-5";
export var notificationBar = "_4e-2";
export var saveButtonHoverSlotWrapper = "_4e-4";
export var show = "_4e-1";
export var spacer = "_4e-0";